// extracted by mini-css-extract-plugin
export var headerXL = "FeatureCard-module--headerXL--3YW72";
export var headerL = "FeatureCard-module--headerL--1oI0L";
export var headerM = "FeatureCard-module--headerM--fWA4D";
export var headerS = "FeatureCard-module--headerS--n9VMs";
export var headerXS = "FeatureCard-module--headerXS--5AEhx";
export var blogHeaderXL = "FeatureCard-module--blogHeaderXL--1zOZM";
export var blogHeaderL = "FeatureCard-module--blogHeaderL--2To1Z";
export var blogHeaderM = "FeatureCard-module--blogHeaderM--3i8q3";
export var blogHeaderS = "FeatureCard-module--blogHeaderS--4mKhn";
export var blogHeaderXS = "FeatureCard-module--blogHeaderXS--3B0JX";
export var headerPreamble = "FeatureCard-module--headerPreamble--2avmc";
export var preHeader = "FeatureCard-module--preHeader--r3gvD";
export var textNormal = "FeatureCard-module--textNormal--1NzXX";
export var textSmall = "FeatureCard-module--textSmall--Ei0Zr";
export var textSmallAlternate = "FeatureCard-module--textSmallAlternate--16H3Z";
export var legend = "FeatureCard-module--legend--UVFEh";
export var caption = "FeatureCard-module--caption--JSmgK";
export var gradientBackground = "FeatureCard-module--gradientBackground--3aQgJ";
export var ellipsis = "FeatureCard-module--ellipsis--2kwCU";
export var globalContainer = "FeatureCard-module--globalContainer--3fgJY";
export var maxWidth = "FeatureCard-module--maxWidth--48Xus";
export var clipBottom = "FeatureCard-module--clipBottom--kIEiD";
export var clipTopBottom = "FeatureCard-module--clipTopBottom--1HWZa";
export var card = "FeatureCard-module--card--2HZzc";
export var inverted = "FeatureCard-module--inverted--1L3xJ";
export var ch2 = "FeatureCard-module--ch2--1zipf";
export var ch2Container = "FeatureCard-module--ch2-container--18aCS";